import { render, staticRenderFns } from "./AccountingEmployees.vue?vue&type=template&id=18565c28&"
import script from "./AccountingEmployees.vue?vue&type=script&lang=ts&"
export * from "./AccountingEmployees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports